interface Props {
    className?: string
    pathClassName?: string
    FillColor?: string
}

export default function Cookie({
                                     FillColor = '',
                                     className = '',
                                     pathClassName = ''
                                 }: Props) {
    return (
        <svg viewBox="0 0 24 24" className={className}>
            <path
                d="M12 10.4858C12 11.3142 11.3284 11.9858 10.5 11.9858C9.67157 11.9858 9 11.3142 9 10.4858C9 9.65735 9.67157 8.98578 10.5 8.98578C11.3284 8.98578 12 9.65735 12 10.4858Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M9 17.9858C9.82843 17.9858 10.5 17.3142 10.5 16.4858C10.5 15.6574 9.82843 14.9858 9 14.9858C8.17157 14.9858 7.5 15.6574 7.5 16.4858C7.5 17.3142 8.17157 17.9858 9 17.9858Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M10.5 5.98578C10.5 6.39999 10.1642 6.73578 9.75 6.73578C9.33579 6.73578 9 6.39999 9 5.98578C9 5.57157 9.33579 5.23578 9.75 5.23578C10.1642 5.23578 10.5 5.57157 10.5 5.98578Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M5.25 11.9858C5.66421 11.9858 6 11.65 6 11.2358C6 10.8216 5.66421 10.4858 5.25 10.4858C4.83579 10.4858 4.5 10.8216 4.5 11.2358C4.5 11.65 4.83579 11.9858 5.25 11.9858Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M13.5 14.2358C13.5 14.65 13.1642 14.9858 12.75 14.9858C12.3358 14.9858 12 14.65 12 14.2358C12 13.8216 12.3358 13.4858 12.75 13.4858C13.1642 13.4858 13.5 13.8216 13.5 14.2358Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M16.5 16.4858C17.3284 16.4858 18 15.8142 18 14.9858C18 14.1574 17.3284 13.4858 16.5 13.4858C15.6716 13.4858 15 14.1574 15 14.9858C15 15.8142 15.6716 16.4858 16.5 16.4858Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M11.7582 1.71252C11.9112 1.85343 11.9988 2.05154 12.0001 2.25953C12.0072 3.41606 12.5372 4.44815 13.3683 5.13248C13.5983 5.32182 13.6944 5.62931 13.6132 5.91591C13.5396 6.17563 13.5 6.45044 13.5 6.73575C13.5 8.39261 14.8431 9.73575 16.5 9.73575C16.7491 9.73575 16.99 9.70556 17.2199 9.649C17.4723 9.5869 17.7388 9.6599 17.9243 9.84193C18.331 10.2409 18.8862 10.4858 19.5 10.4858C20.1193 10.4858 20.679 10.2365 21.0866 9.83107C21.2855 9.63329 21.5781 9.56299 21.8451 9.64882C22.1121 9.73466 22.3089 9.9623 22.3552 10.2389C22.4505 10.8075 22.5 11.3911 22.5 11.9858C22.5 17.7847 17.799 22.4858 12 22.4858C6.20101 22.4858 1.5 17.7847 1.5 11.9858C1.5 6.45815 5.77081 1.92876 11.1932 1.51632C11.4006 1.50055 11.6052 1.5716 11.7582 1.71252ZM10.5706 3.09854C6.27967 3.78305 3 7.50171 3 11.9858C3 16.9563 7.02944 20.9858 12 20.9858C16.9706 20.9858 21 16.9563 21 11.9858C21 11.882 20.9982 11.7787 20.9948 11.6758C20.5367 11.8751 20.0311 11.9858 19.5 11.9858C18.6256 11.9858 17.8202 11.6858 17.1827 11.1842C16.9597 11.2182 16.7317 11.2358 16.5 11.2358C14.0147 11.2358 12 9.22103 12 6.73575C12 6.47667 12.022 6.22226 12.0643 5.97442C11.2932 5.21414 10.7555 4.21588 10.5706 3.09854Z"
                fill={FillColor}
                className={pathClassName}/>


        </svg>
    )
}
